/* product-card-effects.js
 * EMI/offer rotator and rotating-badge behavior for product cards.
 * Previously this logic was inlined as two <script> blocks inside
 * snippets/product-card.liquid, which renders once PER PRODUCT CARD -
 * on a collection page with 48 cards that meant 48 duplicate copies of
 * these functions, each re-registering its own DOMContentLoaded listener
 * and (for the rotating badge) re-running querySelectorAll('.rotating-badge')
 * over the WHOLE page with no re-init guard. That created N-per-card
 * setInterval timers all fighting over the same badges, and inflated page
 * weight enough to risk response truncation. This file runs once per page
 * and initializes each element exactly once, no matter how many product
 * cards are on the page or how many times cards are re-rendered
 * (AJAX filters, predictive search, complementary products).
 */
(function () {
  function initEmiOfferRotators(root) {
    root.querySelectorAll('.emi-offer-container').forEach((container) => {
      if (container.dataset.initialized === 'true') return;
      container.dataset.initialized = 'true';

      const emi = container.querySelector('.emi-text');
      const offer = container.querySelector('.offer-text');
      if (!emi || !offer) return;

      let showEmi = true;
      let isPaused = false;

      function switchText() {
        if (isPaused) return;

        if (showEmi) {
          emi.classList.remove('active');
          emi.classList.add('exit-up');

          offer.classList.remove('exit-up');
          offer.classList.add('active');
        } else {
          offer.classList.remove('active');
          offer.classList.add('exit-up');

          emi.classList.remove('exit-up');
          emi.classList.add('active');
        }

        showEmi = !showEmi;
      }

      setInterval(switchText, 4000);

      container.addEventListener('mouseenter', () => {
        isPaused = true;
      });
      container.addEventListener('mouseleave', () => {
        isPaused = false;
      });
    });
  }

  function initRotatingBadges(root) {
    root.querySelectorAll('.rotating-badge').forEach((badge) => {
      if (badge.dataset.badgeInitialized === 'true') return;
      badge.dataset.badgeInitialized = 'true';

      let messages;
      try {
        messages = JSON.parse(badge.dataset.messages);
      } catch (e) {
        return;
      }
      const color1 = badge.dataset.color1;
      const color2 = badge.dataset.color2;
      const textElement = badge.querySelector('.rotating-text');
      if (!textElement || !messages || !messages.length) return;

      let currentIndex = 0;

      textElement.textContent = messages[0].trim();
      badge.style.backgroundColor = color1;

      setInterval(() => {
        textElement.style.opacity = '0';

        setTimeout(() => {
          currentIndex = (currentIndex + 1) % messages.length;
          textElement.textContent = messages[currentIndex].trim();

          if (currentIndex === 0) {
            badge.style.backgroundColor = color1;
          } else if (currentIndex === 1) {
            badge.style.backgroundColor = color2;
          } else {
            badge.style.backgroundColor = currentIndex % 2 === 0 ? color1 : color2;
          }

          textElement.style.opacity = '1';
        }, 250);
      }, 4000);
    });
  }

  function initAll(root) {
    initEmiOfferRotators(root);
    initRotatingBadges(root);
  }

  document.addEventListener('DOMContentLoaded', () => initAll(document));
  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target || document);
  });

  // Catch product cards injected later without a page navigation:
  // predictive search results, "complementary products" widget, AJAX
  // collection filtering.
  let rescanTimer = null;
  new MutationObserver((mutations) => {
    let shouldRescan = false;
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        shouldRescan = true;
        break;
      }
    }
    if (!shouldRescan) return;
    clearTimeout(rescanTimer);
    rescanTimer = setTimeout(() => initAll(document), 150);
  }).observe(document.body, { childList: true, subtree: true });
})();
